// Page-specific SEO Configuration
// Each page has unique title, description, keywords, and schema

export const seoImage = "https://appdeveloperpro.com/images/app-developer-pro-web-mobile-software-development.png";

export const pageSeoData = {
  home: {
    title: "App Developer Pro | Web/Mobile Apps & Software Development",
    description: "Join the App Developer Program to reach customers around the world via custom web/mobile apps development services in USA, India. #No1 Software Solutions.",
    keywords: "app developer, web apps development, mobile apps development, software development",
    url: "https://appdeveloperpro.com",
    schema: {
      "@type": "WebPage",
      name: "Home - App Developer Pro",
      description: "Professional web/mobile apps & software development services",
    }
  },
  
  fullstackexpert: {
    title: "Full Stack Expert - Development Solutions Specialist in USA",
    description: "USA based full stack expert is specialist in web/mobile apps & software development solutions and delivering high performance digital services across the world.",
    keywords: "full stack expert, Development Solutions Specialist, mobile apps development India, apps development services USA",
    url: "https://appdeveloperpro.com/full-stack-expert",
    schema: {
      "@type": "Full Stack Expert",
      name: "About Full Stack Expert Pro",
      description: "Learn about full stack expert services",
    }
  },
  
  DevelopmentProcess: {
    title: "Development Process - Web/Mobile & Software Expert USA-India",
    description: "At App Developer Pro, Discover my web/mobile & software development process & learn more about a full stack expert in USA, India, Spain, Germany, Ireland & UK.",
    keywords: "development process, full stack expert USA, agile development India, software development Spain, transparent development Germany",
    url: "https://appdeveloperpro.com/development-process",
    schema: {
      "@type": "DefinedProcess",
      name: "Development Process",
      description: "At App Developer Pro, web/mobile & software expert follows a defined development process to ensure quality and efficiency.",
    }
  },
  
  whoWeAre: {
    title: "Who We Are - App Developer Pro | Your Digital Transformation Partner",
    description: "Learn about App Developer Pro - a leading web and mobile app development company delivering innovative, scalable digital solutions. 10+ years of experience, 80+ projects, and 50+ satisfied clients worldwide.",
    keywords: "app developer pro, web development company, mobile app development, software development services, custom app development, digital transformation, about us",
    url: "https://appdeveloperpro.com/who-we-are",
    schema: {
      "@type": "AboutPage",
      name: "Who We Are - App Developer Pro",
      description: "Learn about our company, values, and commitment to excellence",
    }
  },
  
  portfolio: {
    title: "Development Portfolio - Check Full Stack Expert's Projects",
    description: "Explore our web & mobile application development portfolio of successful web applications, mobile apps, e-commerce platforms, and digital solutions delivered to clients worldwide.",
    keywords: "development portfolio, web app examples, mobile app showcase, development case studies, client projects",
    url: "https://appdeveloperpro.com/portfolio",
    schema: {
      "@type": "CollectionPage",
      name: "Development Portfolio - App Developer Pro",
      description: "Showcase of completed projects",
    }
  },
  
  blogs: {
    title: "Blog - Tech Insights & Development Tips | App Developer Pro",
    description: "Read expert articles on web development, mobile apps, programming tutorials, industry trends, SEO, and technology insights from App Developer Pro.",
    keywords: "web development blog, mobile app tutorials, programming tips, tech articles, software development insights",
    url: "https://appdeveloperpro.com/blogs",
    schema: {
      "@type": "Blog",
      name: "App Developer Pro Blog",
      description: "Technical articles and development insights",
    }
  },
  
  reviews: {
    title: "Development Reviews | App Developer Pro",
    description: "Read authentic web & mobile application development reviews and testimonials from satisfied clients who chose App Developer Pro for web development, mobile apps, and digital solutions.",
    keywords: "development reviews, client testimonials, customer feedback, app developer ratings, development company reviews",
    url: "https://appdeveloperpro.com/development-reviews",
    schema: {
      "@type": "ReviewPage",
      name: "Development Reviews",
      description: "Customer testimonials and feedback",
    }
  },
  
  contact: {
    title: "Contact Development Services - Full Stack AI Driven Development",
    description: "Contact App Developer Pro for a free consultation about development services. Discuss your web development, mobile app, or digital project requirements with our expert team.",
    keywords: "contact development services, contact app developer, get quote, free consultation, hire developers, project inquiry",
    url: "https://appdeveloperpro.com/contact",
    schema: {
      "@type": "ContactPage",
      name: "Contact App Developer Pro",
      description: "Get in touch for project inquiries",
    }
  },
  
  faq: {
    title: "FAQ - Frequently Asked Questions | App Developer Pro",
    description: "Find answers to common questions about our web development, mobile app development services, pricing, timelines, and processes.",
    keywords: "development FAQ, app development questions, web development pricing, mobile app cost, project timeline",
    url: "https://appdeveloperpro.com/faq",
    schema: {
      "@type": "FAQPage",
      name: "Frequently Asked Questions",
      description: "Common questions about our services",
    }
  },
  
  pricing: {
    title: "Pricing Plans - Web & Mobile App Development | App Developer Pro",
    description: "Transparent pricing for web development, mobile apps, UI/UX design, and digital solutions. Choose the perfect plan for your business needs.",
    keywords: "development pricing, web app cost, mobile app pricing, package plans, development rates",
    url: "https://appdeveloperpro.com/pricing",
    schema: {
      "@type": "OfferCatalog",
      name: "Service Pricing Plans",
      description: "Pricing options for development services",
    }
  },
  
  disclaimer: {
    title: "Disclaimer | App Developer Pro",
    description: "Read the disclaimer for App Developer Pro website. Information about content accuracy, liability limitations, and external links.",
    keywords: "website disclaimer, legal disclaimer, content disclaimer",
    url: "https://appdeveloperpro.com/disclaimer",
    schema: {
      "@type": "WebPage",
      name: "Disclaimer",
      description: "Website disclaimer and legal information",
    }
  },
  
  terms: {
    title: "Terms & Conditions | App Developer Pro",
    description: "Terms and conditions for using App Developer Pro services. Read our service agreements, policies, and user terms.",
    keywords: "terms and conditions, service terms, user agreement, legal terms",
    url: "https://appdeveloperpro.com/terms",
    schema: {
      "@type": "WebPage",
      name: "Terms & Conditions",
      description: "Service terms and conditions",
    }
  },
  
  privacy: {
    title: "Privacy Policy | App Developer Pro",
    description: "Privacy policy for App Developer Pro. Learn how we collect, use, and protect your personal information and data.",
    keywords: "privacy policy, data protection, GDPR compliance, information security",
    url: "https://appdeveloperpro.com/privacy",
    schema: {
      "@type": "WebPage",
      name: "Privacy Policy",
      description: "Data privacy and protection policy",
    }
  }
};

// Service-specific SEO data
export const serviceSeoData = {
  webDevelopment: {
    title: "Web Development | React, Angular, Vue.Js, Node.JS, Python, PHP Services",
    description: "USA based, App developer pro is offering cheapest custom website development services using react, Angular, Vue.js, node.js, python, PHP technologies in India, Spain.",
    keywords: "web development, cheap custom website development, React-Angular development, Vue.Js Development, Node.js development, Python developer, PHP developer",
    url: "https://appdeveloperpro.com/services/web-development"
  },
  
  webApplication: {
    title: "Web Application Development Services - Custom SaaS & Enterprise Apps",
    description: "Develop high performance, custom web applications with React, Node.js, cloud-native architecture. SaaS platforms, enterprise apps, real-time systems, and analytics.",
    keywords: "web application development, SaaS development, enterprise apps, React apps, cloud-native applications, cheap ai web app developer USA-Spain-Germany",
    url: "https://appdeveloperpro.com/services/web-application-development"
  },
  
  mobileApps: {
    title: "Mobile App Development - iOS & Android Apps | App Developer Pro",
    description: "Native and cross-platform mobile app development using React Native, Flutter, Swift, and Kotlin for iOS and Android platforms.",
    keywords: "mobile app development, iOS app development, Android development, React Native, Flutter apps",
    url: "https://appdeveloperpro.com/services/mobile-app-development"
  },
  
  uiUxDesign: {
    title: "UI/UX Design Services - User Interface & Experience Design",
    description: "Professional UI/UX design services. User research, wireframing, prototyping, design systems, and user-centered design solutions.",
    keywords: "UI/UX design, user interface design, user experience, wireframing, prototyping, design systems",
    url: "https://appdeveloperpro.com/services/ui-ux-design"
  },
  
  ecommerce: {
    title: "E-commerce Development - Online Store Solutions | App Developer Pro",
    description: "Complete e-commerce development with shopping cart, payment gateway integration, inventory management, and order processing systems.",
    keywords: "e-commerce development, online store, shopping cart, payment gateway, Shopify, WooCommerce",
    url: "https://appdeveloperpro.com/services/ecommerce-development"
  },
  
  digitalMarketing: {
    title: "Digital Marketing Services - SEO, Social Media, PPC | App Developer Pro",
    description: "Strategic digital marketing services including SEO optimization, social media marketing, Google Ads, content marketing, and analytics.",
    keywords: "digital marketing, SEO services, social media marketing, Google Ads, content marketing, PPC",
    url: "https://appdeveloperpro.com/services/digital-marketing"
  },
  
  cloudSolutions: {
    title: "Cloud Solutions - AWS, Azure, GCP Services | App Developer Pro",
    description: "Scalable cloud infrastructure and migration services. AWS, Azure, Google Cloud Platform deployment, auto-scaling, and security.",
    keywords: "cloud solutions, AWS services, Azure cloud, Google Cloud, cloud migration, infrastructure",
    url: "https://appdeveloperpro.com/services/cloud-solutions"
  },
  
  devops: {
    title: "DevOps Services - CI/CD, Automation & Infrastructure | App Developer Pro",
    description: "DevOps services with automated CI/CD pipelines, Docker, Kubernetes, infrastructure management, and deployment automation.",
    keywords: "DevOps services, CI/CD pipeline, Docker, Kubernetes, automation, infrastructure management",
    url: "https://appdeveloperpro.com/services/devops"
  }
};
